
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { notificationDefinitionService } from '../../services/notification-definition-service';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import React, { useState } from 'react';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';



const NotificationSubList = (props: DataGridTypes.MasterDetailTemplateData) => {
    const { id } = props.data.data;
    const [mainStore] = useState(() => createCustomStore({
        key: 'id',
        load: notificationDefinitionService.getListAsync,
        insert: (values) => {
            values.groupId = id;
            return notificationDefinitionService.createAsync(values);
        },
        update: (key, values) => {
            values.groupId = id;
            return notificationDefinitionService.updateAsync(`${key}`, values);
        },
        remove: (key) => {
            return notificationDefinitionService.deleteAsync(`${key}`);
        },
        onLoading(loadOptions) {
            if (id) {
                loadOptions.filter = [["groupId", "=", id]]
            }
        },
    }));
    const handleRowUpdating = async (e: any) => {
        e.newData = { ...e.oldData, ...e.newData }
    };
    return (

        <React.Fragment>
            <DataGridWrapper
                props={{
                    id: 'notification-list', remoteOperations: true,

                    keyExpr: "id"
                }}
                permissonCode='Admin.Notification.NotificationDefinition'
                datasource={mainStore}
                pagerVisible={true}
                headerFilterVisible={true}
                onRowUpdating={handleRowUpdating}
                columns={[
                    {
                        dataField: 'code',
                        caption: t('code'),
                        filtering: false,
                        allowSearch: false,
                    },
                    {
                        dataField: 'description',
                        caption: t('description'),
                        filtering: false,
                        allowSearch: false,
                    },
                    {
                        dataField: 'isActive',
                        caption: t('active'),
                        filtering: false,
                        allowSearch: false,
                        dataType: 'boolean',
                        calculateCellValue: (rowData: any) => {
                            return rowData.isActive || false;
                        },
                    },
                ]}
            />
        </React.Fragment>
    )
}
export default NotificationSubList